<template>
  <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%">
    <el-table-column
            fixed
            type="index"
            label="序号"
            :index="indexMethod"
            width="100">
    </el-table-column>
    <el-table-column
            prop="versionName"
            label="版本名称（版本号）"
            width="180">
    </el-table-column>
    <el-table-column
            prop="createTime"
            label="创建时间"
            width="180">
    </el-table-column>
    <el-table-column
            prop="updateTime"
            label="最近修改时间"
            width="180">
    </el-table-column>
    <el-table-column
            label="操作"
            width="150">
      <template slot-scope="scope">
        <el-button type="text" size="small" @click="update(scope.row.id)">修改</el-button>
        <el-button type="text" size="small" @click="del(scope.row.id)">
          <p class="red">删除</p>
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
  export default {
    name: "LabelTable",
    props: {
      tableData: Array
    },
    data() {
      return {
      }
    },
    methods: {
      indexMethod(index) {
        return index+1;
      },
      update(id){
        this.$emit("update",id)
      },
      del(id){
        this.$emit("del",id)
      }
    },
  }
</script>

<style scoped>
  .red{
    color: red;
  }
</style>
